import { getEntityType } from "../../../helpers/dataBackend";
import React, { useEffect, useState } from "react";
import {
  Row,
  Label,
  Input,
  Form,
  FormGroup,
  Button,
  Card,
  CardBody,
} from "reactstrap";

interface BasicInformationProps {
  onSubmit: (values: any) => void;
  onBack: () => void;
  data?: any;
}

const HoldersInformation = ({
  onSubmit,
  onBack,
  data,
}: BasicInformationProps) => {
  document.title = "Ditobanx";

  const [shareholders, setShareholders] = useState<any[]>([]);
  const [entityTypes, setEntityTypes] = useState<any[]>([]);
  const [typeEntitySelected, setTypeEntitySelected] = useState<string>("");

  const handleAddShareholder = () => {
    const newShareholder = {
      fullName: "",
      documentNumber: "",
      percentage: 0,
      isPep: false, // Ahora es booleano
      entityType: "", //Para saber si es empresa o persona natural
    };
    setShareholders([...shareholders, newShareholder]);
  };

  const handleRemoveShareholder = (index: number) => {
    const updatedShareholders = [...shareholders];
    updatedShareholders.splice(index, 1);
    setShareholders(updatedShareholders);
  };

  const handleChangeShareholder = (
    index: number,
    field: string,
    value: any
  ) => {
    const updatedShareholders = [...shareholders];
    updatedShareholders[index][field] = value;
    setShareholders(updatedShareholders);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    // console.log("Datos de accionistas:", shareholders);
    shareholders.forEach((item) => {
      item.percentage = Number(item.percentage);
    });
    // console.log(shareholders);
    onSubmit(shareholders);
  };

  useEffect(() => {
    const getData = async () => {
      const entityTypes = await getEntityType();
      setEntityTypes(JSON.parse(entityTypes.data));
    };
    getData();
  }, []);

  return (
    <React.Fragment>
      <Form onSubmit={handleSubmit} autoComplete="off">
        <p className="text-muted-foreground mb-4">
          Registra la información de accionistas y beneficiarios finales con más
          de 10% de participación.
        </p>
        <Row>
          {shareholders.map((shareholder, index) => (
            <Card key={index} className="bg-light">
              <CardBody className="pt-6">
                <div className="d-flex justify-content-between items-center mb-4">
                  <h4 className="text-sm font-medium">
                    Accionista {index + 1}
                  </h4>
                  <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    onClick={() => handleRemoveShareholder(index)}
                  >
                    <i className="bx bxs-trash-alt"></i>
                  </Button>
                </div>

                {/* Nombre Completo */}
                <FormGroup className="mb-3">
                  <Label htmlFor="fullName">
                    Nombre completo de Accionista
                  </Label>
                  <Input
                    type="text"
                    id="fullName"
                    placeholder="Nombre completo del accionista"
                    value={shareholder.fullName}
                    onChange={(e) =>
                      handleChangeShareholder(index, "fullName", e.target.value)
                    }
                    required
                  />
                </FormGroup>

                {/* Número de Documento */}
                <FormGroup className="mb-3">
                  <Label htmlFor="documentNumber">
                    Número de identificación
                  </Label>
                  <Input
                    type="text"
                    id="documentNumber"
                    placeholder="Número de identificación"
                    value={shareholder.documentNumber}
                    onChange={(e) =>
                      handleChangeShareholder(
                        index,
                        "documentNumber",
                        e.target.value
                      )
                    }
                    required
                  />
                </FormGroup>

                {/* Porcentaje */}
                <FormGroup className="mb-3">
                  <Label htmlFor="percentage">Porcentaje (%)</Label>
                  <Input
                    type="number"
                    id="percentage"
                    placeholder="Porcentaje de participación"
                    value={shareholder.percentage}
                    onChange={(e) =>
                      handleChangeShareholder(
                        index,
                        "percentage",
                        e.target.value
                      )
                    }
                    required
                  />
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label htmlFor="document_type"> Tipo de accionista </Label>
                  <select
                    className="form-control"
                    name="document_type"
                    id="document_type"
                    value={shareholder.entityType || ""}
                    // onChange={(e) => {
                    //   setTypeEntitySelected(e.target.value);
                    // }}
                    onChange={(e) =>
                      handleChangeShareholder(
                        index,
                        "entityType",
                        e.target.value
                      )
                    }
                  >
                    <option value="" selected disabled>
                      Elige una opcion
                    </option>
                    {entityTypes.map((item: any) => (
                      <option key={item.code} value={item.code}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                {/* IS PEP (checkbox) */}
                <FormGroup className="mb-4">
                  {/* Título */}
                  <Label tag="h6">Información sobre PEP</Label>
                  {/* Texto largo con scroll */}
                  <div
                    style={{
                      maxHeight: "120px",
                      overflowY: "auto",
                      padding: "8px",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <p>
                      De acuerdo con la Ley Contra el Lavado de Dinero y de
                      Activos y las normas de la Superintendencia del Sistema
                      Financiero (SSF), se considera PEP a:
                      <br />
                      <br />
                      “Las personas naturales que desempeñan o han desempeñado
                      funciones públicas destacadas en un país o en una
                      organización internacional, incluyendo jefes de Estado o
                      de Gobierno, altos funcionarios gubernamentales,
                      judiciales o militares, altos ejecutivos de empresas
                      estatales o importantes partidos políticos.”
                    </p>
                  </div>
                  <FormGroup check className="mt-3">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={shareholder.isPep}
                        onChange={(e) =>
                          handleChangeShareholder(
                            index,
                            "isPep",
                            e.target.checked
                          )
                        }
                      />
                      ¿Es Persona Políticamente Expuesta (PEP)?
                    </Label>
                  </FormGroup>
                </FormGroup>
              </CardBody>
            </Card>
          ))}

          <Button
            type="button"
            variant="outline"
            onClick={handleAddShareholder}
            className="btn btn-success"
          >
            Agregar accionista
          </Button>
        </Row>

        <p className="mt-4">
          Los accionistas con participación mayor al 10% deberán completar un
          proceso de verificación KYC adicional.
        </p>

        <div
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          {/* <button
            type="button"
            className="btn btn-secondary me-2"
            onClick={onBack}
          >
            Regresar
          </button> */}
          <button type="submit" className="btn btn-primary">
            Siguiente
          </button>
        </div>
      </Form>
    </React.Fragment>
  );
};

export default HoldersInformation;
